import { useNavigate } from 'react-router-dom'

import { GenericCancelDialog } from '~/common/components'
import { links } from '~/AppRoutes'

type Props = {
  open: boolean
  onCancel: () => void
}

export const CancelDialog = ({ open, onCancel }: Props) => {
  const navigate = useNavigate()
  return <GenericCancelDialog open={open} onAccept={() => navigate(links.usersLink())} onReject={onCancel} />
}
